<template>
  <div class="custom-select-tag-head">
    <tag
      :title="title"
    />

    <button
      class="custom-select-tag-head__button-reset"
      @click.stop="$emit('clear')"
    >
      <f-sprite-icon
        :icon-link="$options.icons.IconCloseFat.id"
        slot="icon"
      />
    </button>
  </div>
</template>

<script>
import Tag from '@kit/tag/tag.vue';
import IconCloseFat from '@icons/close-fat.svg'

export default {
  components: {
    Tag,
  },

  icons: {
    IconCloseFat
  },

  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
  .custom-select-tag-head {
    display: flex;

    &__button-reset {
      color: $gray_lu;
      background: none;
      width: 24px;
      height: 24px;
      margin-left: 8px;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
</style>
